<template>
  <div class="video-timeline-slider">
    <slider :value="position" @update="onSliderUpdate"></slider>
    <div class="time-readout">{{ msToTime(currentTime * 1000) }}</div>
    <div class="time-readout right"> - {{ msToTime(timeLeft * 1000) }}</div>
  </div>
</template>

<style lang="scss">
.video-timeline-slider {
  position: absolute;
  width: 100%;
  height: 29px;
  z-index: 1;
  background: rgba(0,0,0,.4);
  bottom: 0;

  .slider {
    background: rgba(255,255,255,0.8);
    width: calc(100% - 20px);
    margin-left: 10px;
    height: 29px;
    padding: 7px 0 20px;
    background-clip: content-box;
    z-index: 1;
  }

  .thumb {
    width: 20px;
    left: -10px;
    top: -7px;
    height: 100%;

    &:before {
      position: absolute;
      content: ' ';
      width: 8px;
      height: 7px;
      background-color: #ff9e00;
      top: 12px;
      left: 6px;   
    }

    &:after {
      position: absolute;
      content: ' ';
      top: 7px;
      width: 0;
      height: 0;
      left: 6px;
      background: transparent;
      border-left: 4px solid transparent;
      border-right: 4px solid transparent;
      border-bottom: 5px solid #ff9e00;
    }
  }

  .time-readout {
    color: #fff;
    position: absolute;
    bottom: 2px;
    font-size: 9px;
    font-weight: 600;
    left: 10px;

    &.right {
      left: auto;
      right: 10px;
    }
  }
}
</style>

<script>
import Slider from '@/components/Slider'
import msToTime from '@/utils/ms-to-time'

export default {
  components: {
    Slider
  },

  mixins: [
    msToTime
  ],

  props: [
    'video'
  ],

  data () {
    return {
      duration: 0,
      currentTime: 0
    }
  },

  computed: {
    timeLeft () {
      return this.duration - this.currentTime
    },
    position () {
      return (100 / this.duration) * this.currentTime || 0
    }
  },

  watch: {
    video () {
      this.video.addEventListener('timeupdate', () => {
        this.currentTime = this.video.currentTime
      })
      this.video.addEventListener('durationchange', () => {
        this.duration = this.video.duration
      })
    }
  },

  methods: {
    onSliderUpdate (value) {
      this.video.currentTime = this.video.duration * (value / 100)
    }
  }
}
</script>





// WEBPACK FOOTER //
// TimelineSlider.vue?71fb8054